import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { AthletePageLayout } from "src/pages/AthletePageLayout";
import { createOrganizationAthletesRepository } from "src/repositories/athletes/createOrganizationAthletesRepository";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId",
)({
  component: RouteComponent,
  ssr: true,
  async loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        if (organization.role !== "OWNER") throw notFound();

        const repository = createOrganizationAthletesRepository(
          organization.id,
        );
        const profile = await context.queryClient.query({
          ...repository.profileOptions(params.athleteId),
          staleTime: "static",
        });
        return {
          data: { organization, profile },
          breadcrumb: {
            id: profile.athlete.userId,
            label: profile.athlete.user.name,
            href: `/orgs/${params.slug}/athletes/${params.athleteId}/profile`,
          },
        };
      },
    );
  },
});

function RouteComponent() {
  const { slug, athleteId } = Route.useParams();
  return (
    <AthletePageLayout
      key={`${slug}:${athleteId}`}
      config={{
        athleteId,
        basePath: `/orgs/${slug}/athletes/${athleteId}`,
        tabs: [
          {
            id: "profile",
            link: {
              to: "/orgs/$slug/athletes/$athleteId/profile",
              params: { slug, athleteId },
            },
          },
          {
            id: "metrics",
            link: {
              to: "/orgs/$slug/athletes/$athleteId/metrics",
              params: { slug, athleteId },
            },
          },
          {
            id: "statistics",
            link: {
              to: "/orgs/$slug/athletes/$athleteId/statistics",
              params: { slug, athleteId },
            },
          },
          {
            id: "questionnaires",
            link: {
              to: "/orgs/$slug/athletes/$athleteId/questionnaires",
              params: { slug, athleteId },
            },
          },
        ],
      }}
    >
      <Outlet />
    </AthletePageLayout>
  );
}
